import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { PriceParams } from '@platform-frontend/transloco';
import { TranslationId } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PricingInformation } from '../pricing-information';
import { ExtendedSubscriptionInterval, SubscriptionIntervalParams } from '../product';

@Injectable()
export class SubscriptionPriceUpdateService {
  constructor(private http: HttpClient) {}

  buildSinglePriceUpdateNotificationMessage(
    notificationMessage: (product: string, oldPrice: PriceParams, newPrice: PriceParams, period: SubscriptionIntervalParams) => TranslationId,
    productName: string,
    oldPricing: PricingInformation,
    newPricing: PricingInformation,
    subscriptionInterval: ExtendedSubscriptionInterval
  ): TranslationId {
    const oldPrice: PriceParams = { price: oldPricing.total, currency: oldPricing.currency };
    const newPrice: PriceParams = { price: newPricing.total, currency: newPricing.currency };
    const subscriptionIntervalParams: SubscriptionIntervalParams = { interval: subscriptionInterval, displayMode: 'adverb' };
    return notificationMessage(productName, oldPrice, newPrice, subscriptionIntervalParams);
  }

  confirmPriceUpdates(licenseTypeIds: string[]): Observable<unknown> {
    return this.http.post<void>(PLATFORM_ENVIRONMENT.apiUrl + '/price-updates/confirm', { licenseTypeIds }).pipe(catchError(() => of(null)));
  }
}
